import { useCallback, useMemo, useState } from 'react'

import { Trans } from '@mc/i18n'

import { trackPageClicked, PageClickedProps } from '../../events/pageClicked'
import { PERSONA_IN_TIERS_I18N_NAMESPACE } from '../../i18n'
import { ExplainerModal } from '../ExplainerModal'
import { Icon, type IconKind } from './icons/Icon'

export type Props = {
  itemContainerClasses: string
  trackProps: Omit<PageClickedProps, 'action' | 'type'>
}

export const SubscriptionProps = ({
  itemContainerClasses = '',
  trackProps,
}: Props) => {
  const [showModal, setShowModal] = useState(false)

  const handleClick = useCallback(
    (type: string) => () => {
      trackPageClicked({
        ...trackProps,
        action: 'On Call',
        type,
      })
      setShowModal(true)
    },
    [trackProps],
  )

  const list: { icon: IconKind; text: React.ReactNode }[] = useMemo(
    () => [
      {
        icon: 'chat',
        text: (
          <Trans
            i18nKey='subscription.info.roleplay'
            ns={PERSONA_IN_TIERS_I18N_NAMESPACE}
            components={{
              button: (
                <button
                  className='mc-text--link'
                  onClick={handleClick('roleplay')}
                />
              ),
            }}
          />
        ),
      },
      {
        icon: 'guidance',
        text: (
          <Trans
            i18nKey='subscription.info.guidance'
            ns={PERSONA_IN_TIERS_I18N_NAMESPACE}
            components={{
              button: (
                <button
                  className='mc-text--link'
                  onClick={handleClick('guidance')}
                />
              ),
            }}
          />
        ),
      },
    ],
    [handleClick],
  )

  return (
    <>
      <ExplainerModal
        show={showModal}
        onClose={() => setShowModal(false)}
        location='value-prop'
      />
      {list.map(({ icon, text }, index) => (
        <li
          className={`mc-my-3 ${itemContainerClasses} d-flex`}
          key={`persona-value-prop-${index}`}
        >
          <span className='mc-mr-3'>
            <Icon className='mc-icon--3' kind={icon} />
          </span>
          <span style={{ maxWidth: '340px' }}>{text}</span>
        </li>
      ))}
    </>
  )
}
